import { render, staticRenderFns } from "./VQCheck.vue?vue&type=template&id=119136e0&scoped=true"
import script from "./VQCheck.vue?vue&type=script&lang=js"
export * from "./VQCheck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "119136e0",
  null
  
)

export default component.exports